import styled from "styled-components";

export const StyledWebhookTableFormWrapper = styled.div`
    overflow: visible;

    .ant-table-container {
        & > .ant-table-body {
            overflow: visible !important;
        }

        & > .ant-table-content,
        table > tbody.ant-table-tbody {
            overflow: visible !important;

            td {
                &.queryId-cell {
                    overflow: visible !important;
                }

                &.delete-cell {
                    padding: 0 !important;
                }
            }
        }
    }
`;

export const StyledWebhookAddButtonWrapper = styled.div`
    margin: 8px 0 0 8px;
`;
